// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IDispatcherType = any;

export interface IError {
	name: string;
	message: string;
	code: string;
	stack: string;
	data?: unknown;
}

export interface ISampleResponse {
	message: string;
	api_msg?: string;
	data?: unknown;
	status_code?: string;
}
export interface IInitialState {
	loading: boolean;
	error: string;
	data: unknown;
}

export const INITIAL_STATE = (): IInitialState => ({
	loading: false,
	error: '',
	data: {},
});

export interface IPaymentModesResponse {
	id: number;
	displayName: string;
	code: string;
	icon: string;
	amount: string;
	description: string;
	recommended: boolean;
	enabled: boolean;
	options: any;
}

export interface ISendPaymentModesResponse {
	amount: number;
	beneficiaryName: string;
	status: string;
	currency: string;
	orderId: string;
	paymentURI: string;
	upiIntent: string;
}

interface IACTION<T = unknown> {
	type: string | symbol;
	payload: T;
}
export interface IAPI_ACTION<T = unknown> extends IACTION<T> {
	meta: unknown;
	error: {
		name: string;
		message: string;
		stack: string;
	};
}

export interface IPaymentStatusResponse {
	amount: number;
	beneficiaryName: string;
	status: string;
	currency: string;
	orderId: string;
	paymentURI: string;
	upiIntent?: string;
	redirectURI?: string;
	paymentStatus: string;
}

export interface IGenerateOtpResponse {
	statusCode: string;
	message: string;
	data: any;
}

export interface rzpCardInfoData {
	country: string;
	iin: string;
	issuer: string;
	issuer_name: string;
	message_type: string;
	network: string;
	sub_type: string;
	type: string;
}

export interface rzpCardInfoResponse {
	statusCode: string;
	message: string;
	data: rzpCardInfoData;
}
